import axios from 'axios';

import { API_ROUTE } from '@/constants/apiRoutes';

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL_SOUSCRIRE_EN_LIGNE;
const validationUniversignEndpoint = API_ROUTE.VALIDATION_UNIVERSIGN;

export const getFaireVersementJustificatifsValidationUniversign = async (idSouscription: number) => {
  const versementData = JSON.parse(sessionStorage.parcoursVersementData);

  const response = await axios.post(
    `${apiBaseUrl}${validationUniversignEndpoint}`,
    {
      idSouscription: idSouscription,
    },
    {
      headers: {
        token: `${versementData.token}`,
      },
    }
  );

  if (!response) {
    throw new Error('Erreur lors de la vérification Universign');
  }
  const data = await response.data;
  return data;
};
